/* eslint-disable jsdoc/check-param-names */
import { v4 as uuidv4 } from 'uuid';
/**
 * Generates UUID in v4 string
 *
 * @returns {string} UUID in v4
 *
 * @example
 * createUuid() // returns '824d4409-5bb2-4d0c-aff4-832f87bd93c0'
 */

export var createUuid = uuidv4;
export default createUuid;